import React, { useState, useEffect, useContext, useRef } from 'react';
import { BusinessPlaceStyle } from './Buisness.style';
import { useSelector, useDispatch } from 'react-redux';
import { Notification } from 'components/CustomNotification';
import {
  addBusinessMessage,
  getBuinessPlaceList,
  resetBuinessPlaceList,
} from 'redux/features/BuinessPlaceSlice';
import AddBusinessPlace from './AddBusinessPlace';
import { BasicIconButton, Button, Input, Modal } from 'components';
import { ReactComponent as Add } from 'assert/images/Profile/add.svg';
import { ReactComponent as Search } from 'assert/images/Home/search.svg';
// import { PostBox } from 'pages/home/Home.style';
// import { getBusinessCategoryList } from 'redux/features/DropDownSlice';
// import { Box } from '@mui/material';
import BuinessPlaceLists from './BusinessList';
import { businessList } from 'redux/APIEndPoint';
import { Helmet } from 'react-helmet';
import { t } from 'i18next';
import LoginNotification from 'pages/auth/LoginNotification';
import { AuthContext } from 'router/AuthProvider';
import { InputAdornment } from '@mui/material';

export default function BuisnessPlace({ isProfile, keyword }) {
  const dispatch = useDispatch();
  const debounceRef = useRef(null);
  const { isLoggedIn } = useContext(AuthContext);
  // const {t} = useTranslation();

  // const [scrollData, setscrollData] = useState();
  // const { businessCategory } = useSelector((state) => state?.DropdownReducer);
  const BusinessMessage = useSelector(
    (state) => state.BusinessPlaceSlice.addBusinessMessage
  );

  const [editData, setEditData] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editedItem, setEditedItem] = useState({});
  // const [businessCategoryState, setbusinessCategoryState] = useState('');
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);

  // useEffect(() => {
  //   businessCategory.length === 0 && dispatch(getBusinessCategoryList());
  // }, []);

  useEffect(() => {
    if (BusinessMessage.status === true) {
      Notification('success', BusinessMessage.message);
      dispatch(addBusinessMessage(''));
      setModalOpen(false);
    }
  }, [BusinessMessage]);

  // const ReturnValues = (value) => {
  //   return businessCategory.filter((item) => item.value === value)[0]?.label;
  // };

  const handleSearch = (value) => {
    dispatch(resetBuinessPlaceList());
    dispatch(
      getBuinessPlaceList(
        `${businessList}?keyword=${value}&page=${0}&size=${10}&clientOffSet=${new Date().getTimezoneOffset()}`
      )
    );
  };

  const handleDebouncedSearch = (value) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      handleSearch(value);
    }, 800);
  };

  return (
    <>
      <Helmet>
        <title>Business Hub | WafyNet - Connect and Expand Your Business</title>
        <meta
          name="description"
          content="Explore business profiles, discover companies, and grow your network worldwide with WafyNet. Connect with businesses and expand your opportunities."
        />
      </Helmet>
      <BusinessPlaceStyle>
        {!isProfile && !keyword && (
          <div className="search-container">
            <Input
              value={searchValue}
              onChange={(data) => {
                // setscrollData({
                //   page: 0,
                //   size: 10,
                // });
                setSearchValue(data);
                handleDebouncedSearch(data);
              }}
              placeholder={'Search...'}
              className={'category_list'}
              startAdornment={
                <InputAdornment>
                  <Search />
                </InputAdornment>
              }
            />
            {/* <Select
              Options={businessCategory}
              value={businessCategoryState}
              onChange={(data) => {
                if (isLoggedIn) {
                  setbusinessCategoryState(data.target.value);
                  handleBlur(data.target.value);
                } else {
                  setIsLoginNotificationOpen(true);
                }
              }}
              className={'category_list'}
              startIcon={<Search />}
              displayEmpty
              renderValue={(value) => {
                return (
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Search className="business-filter" />
                    {ReturnValues(value)}
                  </Box>
                );
              }}
            /> */}
            <Button
              className="add-business"
              label={t('BusinessPlace.GrowYourBusiness')}
              startIcon={<Add className="addbutton" />}
              onClick={() => {
                if (isLoggedIn) {
                  setModalOpen(true);
                } else {
                  setIsLoginNotificationOpen(true);
                }
              }}
            />
            <BasicIconButton
              className="add-business-fab"
              iconType="fab"
              ariaLabel="add"
              icon={<Add />}
              onClick={() => setModalOpen(true)}
            />
          </div>
        )}
        {/* <PostBox className='business-page-container'> */}
          <BuinessPlaceLists
            handleSetEditData={setEditData}
            handleOpen={setModalOpen}
            ScrollData={() => {}}
            // ScrollData={(data) => setscrollData(data)}
            // businessCategoryState={businessCategoryState}
            editedItem={editedItem}
            isProfile={isProfile}
            keyword={keyword}
            searchValue={searchValue}
          />
        {/* </PostBox> */}
        <Modal
          content={
            <AddBusinessPlace
              closeModal={() => setModalOpen(false)}
              editData={editData}
              handleUpdateItem={(data) => setEditedItem(data)}
            />
          }
          openModal={modalOpen}
          modelTitle={t('BusinessPlace.GrowYourBusiness')}
          modalchanges="commonModal"
          handleCancelModal={() => {
            setModalOpen(false);
            setEditData('');
          }}
        />
      </BusinessPlaceStyle>
      <LoginNotification
        isLoginNotificationOpen={isLoginNotificationOpen}
        handleUpdateModal={() => setIsLoginNotificationOpen(false)}
      />
    </>
  );
}
